import api from '../../utils/api';
import authStore from './auth';
import store from '../index';

const state = {
	loanLimit: null,
	paymentBreakdown: null,
	termsAndCondition: null,
	transaction: null,
	transactionStatus: null,
	isCompleted: null,
	partners: null,
	insurers: null,
	isStanbicNewUser: null,
	selectedInsurer: null,
	signUpStanbicNewUserPayload: null
};

const getters = {
	getLoanLimit: (state) => state.loanLimit,
	getPaymentBreakdown: (state) => state.paymentBreakdown,
	getTermsAndCondition: (state) => state.termsAndCondition,
	getTransaction: (state) => state.transaction,
	getTransactionStatus: (state) => state.transactionStatus,
	getIsCompleted: (state) => state.isCompleted,
	getPartners: (state) => state.partners,
	getInsurers: (state) => state.insurers,
	getIsStanbicNewUser: (state) => state.isStanbicNewUser,
	getSelectedInsurer: (state) => state.selectedInsurer,
	getSignUpStanbicNewUserPayload: (state) => state.signUpStanbicNewUserPayload
};

const mutations = {
	setLoanLimit: (state, data) => {
		state.loanLimit = data;
	},
	setPaymentBreakdown: (state, data) => {
		state.paymentBreakdown = data;
	},
	setTermsAndCondition: (state, data) => {
		state.termsAndCondition = data;
	},
	setTransaction: (state, data) => {
		state.transaction = data;
	},
	setTransactionStatus: (state, data) => {
		state.transactionStatus = data;
	},
	setIsCompleted: (state, data) => {
		state.isCompleted = data;
	},
	setPartners: (state, data) => {
		state.partners = data;
	},
	setInsurers: (state, data) => {
		state.insurers = data;
	},
	setIsStanbicNewUser: (state, data) => {
		state.isStanbicNewUser = data;
	},
	setSelectedInsurer: (state, data) => {
		state.selectedInsurer = data;
	},
	setSignUpStanbicNewUserPayload: (state, data) => {
		state.signUpStanbicNewUserPayload = data;
	}
};

const actions = {
	stanbicSignIn: ({ commit, dispatch }, data) => {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		api.post('stanbic/accounts/validation', data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				commit('setIsLoading', false);
				commit('setStanbicLoggedInUserData', response.data);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},

	async stanbicVerifyPhoneOtp({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		return api
			.post('stanbic/accounts/verify', data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setLoggedUser', response.user);
				commit('updateToken', response.token);
				commit('setLoanLimit', response.loanLimit);
				commit('setIsStanbicNewUser', response.requiresUserCredential);
				commit('setIsLoading', false);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},

	async resendOtp({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		return api
			.get(`stanbic/accounts/send-otp?accountNumber=${data.accountNumber}&phoneNumber=${data.phoneNumber}`, data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(() => {
				commit('setIsLoading', false);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},

	async paymentBreakDown({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		return api
			.post('stanbic/loans/repayment-details', data)
			.then(async (response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setPaymentBreakdown', response.data);
				commit('setIsLoading', false);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},

	async termsAndCondition({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		return api
			.get('stanbic/terms-and-conditions', data)
			.then(async (response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setTermsAndCondition', response);
				commit('setIsLoading', false);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},

	async takeLoan({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		return api
			.post('stanbic/loans/new', data)
			.then(async (response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setTransaction', response);
				commit('setIsLoading', false);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},

	async fetchTransactionStatus({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		return api
			.get(`stanbic/loans/${data.reference}/status`, data)
			.then(async (response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setIsLoading', false);
				commit('setTransactionStatus', response);
				commit('setIsCompleted', response.isCompleted);
				if (response.isCompleted && response.isSuccessful) {
					commit('setIframeResponseOnSuccess', {
						status: true,
						type: 'SUCCESS',
						data: {
							status: 'successful',
							data: {
								...response,
								reference: state.transaction.reference,
								redirect_url: authStore.state.payload.redirect_url
									? authStore.state.payload.redirect_url
									: false
							}
						}
					});
				}
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},

	async fetchLoanPartnersInsurers({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		return api
			.get(`loans/partners/insurers?is_live=${data.is_live}&partner=${data.partner}`, data)
			.then(async (response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setIsLoading', false);
				commit('setInsurers', response.data);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},

	stanbicSignUp: ({ commit, dispatch }, data) => {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		commit('setIframeResponseOnLoad', {
			status: true,
			type: 'LOADING'
		});
		api.post('loans/account/credentials', data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				commit('setIsLoading', false);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},

	async stanbicFetchApi({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		return api
			.get(`${data.api}`, data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setIsLoading', false);
				commit('addPreviousModal', store.state.nextModal);
				commit('setNextModal', response.next_step);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},

	async stanbicPostApi({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		return api
			.post(`${data.api}`, data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setIsLoading', false);
				if (response?.data?.token) {
					commit('updateToken', response?.data?.token);
				}
				if (!store.state.userPartnerToken) {
					const token = response && response.data && response.data.token ? response.data.token : null;
					await commit('setUserPartnerToken', token);
				}
				if (response.next_step.name === 'LOAN_STATUS') {
					commit('setTransactionReference', response.data.reference);
				}
				commit('addPreviousModal', store.state.nextModal);
				commit('setNextModal', response.next_step);
				if (response?.name === 'CHECKING_LOAN_STATUS') {
					commit('setNextModal', response);
				}
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},

	async stanbicQueryTransactionStatusApi({ commit, dispatch }, data) {
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		return api
			.get(`${data.api}`, data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setQueryTransactionStatus', response.message);
				if (response.is_completed) {
					commit('setIsLoading', false);
					const data = Object.keys(response).includes('next_step')
						? { ...response, name: response.next_step.name }
						: { ...response, name: 'SUCCESSFUL' };
					commit('setNextModal', data);
					if (response.success) {
						commit('setIframeResponseOnSuccess', {
							status: true,
							type: 'SUCCESS',
							data: {
								status: 'successful',
								data: {
									reference: store.state.transactionReference,
									redirect_url: authStore.state.payload.redirect_url
										? authStore.state.payload.redirect_url
										: false
								}
							}
						});
					} else {
						commit('setIframeResponseOnError', {
							message: response.message,
							type: 'ERROR'
						});
					}
				}
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	}
};

export default {
	actions,
	state,
	mutations,
	getters
};
